import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { RAW_COOKIE_SERVICE } from './app.module';

@Injectable()
export class CustomCookieService {
  private skipInvalidValues: string[] = [
    'customerEmail',
    'customerName',
    'customerPhoneNumber',
  ];

  constructor(
    @Inject(RAW_COOKIE_SERVICE) private cookieService: CookieService,
  ) {}

  set(name: string, value: string, ...args: any[]): void {
    if (this.skipInvalidValues.includes(name) && (!value || value === 'null')) {
      console.log(`Invalid value: ${name}=${value}. Removing the cookie.`);
      this.cookieService.delete(name);
    } else {
      this.cookieService.set(name, value, ...args);
    }
  }

  get(name: string): string {
    return this.cookieService.get(name);
  }

  delete(name: string, path?: string): void {
    this.cookieService.delete(name, path);
  }
}
